import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import {
  netural400,
  neturalBlack,
  neturalWhite,
  primaryGrey,
} from "../../constants/color";
import EmptyListPlaceholder from "../empty-list-placeholder/empty-list-placeholder.component";

const DataTable = ({
  title,
  columns,
  data,
  totalCount,
  page,
  pageSize,
  onPageChange,
  totalPages,
  emptyTitle,
  emptySubtitle,
}) => {
  const startItem = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, totalCount);
  const paginatedData = data.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div
      style={{
        backgroundColor: neturalWhite,
        borderRadius: "12px",
        border: `1px solid ${primaryGrey}`,
        marginTop: "5%",
      }}
    >
      {/* Header with title and pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 20px",
          borderBottom: `1px solid ${primaryGrey}`,
        }}
      >
        <label
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: neturalBlack,
          }}
        >
          {title}
        </label>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <label style={{ fontSize: "14px", color: netural400 }}>
            {`${startItem}-${endItem} of ${totalCount}`}
          </label>
          <BsChevronLeft
            color={page <= 1 ? primaryGrey : netural400}
            style={{ cursor: page <= 1 ? "default" : "pointer" }}
            onClick={() => {
              if (page > 1) onPageChange(page - 1);
            }}
          />
          <BsChevronRight
            color={page >= totalPages ? primaryGrey : netural400}
            style={{
              cursor: page >= totalPages ? "default" : "pointer",
            }}
            onClick={() => {
              if (page < totalPages) onPageChange(page + 1);
            }}
          />
        </div>
      </div>

      {/* Table content */}
      {totalCount === 0 ? (
        <EmptyListPlaceholder title={emptyTitle} subtitle={emptySubtitle} />
      ) : (
        <div style={{ padding: "16px 20px" }}>
          {/* Column headers */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "12px",
            }}
          >
            {columns.map((col, index) => (
              <div key={index} style={{ flex: col.flex || 1 }}>
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: neturalBlack,
                  }}
                >
                  {col.label}
                </label>
              </div>
            ))}
          </div>

          {/* Data rows */}
          {paginatedData.map((row, rowIndex) => (
            <div
              key={rowIndex}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "14px 0",
              }}
            >
              {columns.map((col, colIndex) => (
                <div key={colIndex} style={{ flex: col.flex || 1 }}>
                  {col.render ? (
                    col.render(row[col.key], row)
                  ) : (
                    <label style={{ fontSize: "16px", color: neturalBlack }}>
                      {row[col.key]}
                    </label>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DataTable;
